import React, { useState } from 'react';
import fellowships from '../../cms/fellowships.json';
import pageIntros from '../../cms/page-intros.json';
import PageChrome from '../../components/layout/PageChrome';
import JewishLearningCard from '../../components/cards/JewishLearningCard';
import RichText from '../../components/ui/RichText';
import { FaEnvelope, FaExternalLinkAlt, FaClock } from 'react-icons/fa';
import '../../css/student-life/JewishLearning.css';

const intro = pageIntros.jewishLearning || {};

const JewishLearning = () => {
  const [selectedFellowship, setSelectedFellowship] = useState(null);

  const closeModal = () => {
    setSelectedFellowship(null);
  };

  return (
    <>
      <PageChrome
        title={intro.title}
        subtitle={intro.subtitle}
        sectionTitle={intro.sectionTitle}
        intro={intro.intro}
      >
        <section className="jewish-learning-page-section">
          <div className="jewish-learning-page-grid">
            {fellowships.map((fellowship) => (
              <div 
                key={fellowship.id}
                className="jewish-learning-page-card-wrapper"
              >
                <JewishLearningCard 
                  fellowship={fellowship}
                  onClick={() => setSelectedFellowship(fellowship)}
                />
              </div>
            ))}
          </div>
        </section>
      </PageChrome>

      {/* Jewish Learning Modal */}
      {selectedFellowship && (
        <div className="jewish-learning-modal-overlay" onClick={closeModal}>
          <div className="jewish-learning-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="jewish-learning-modal-close" onClick={closeModal}>×</button>
            <div className="jewish-learning-modal-header">
              <h2 className="jewish-learning-modal-name">{selectedFellowship.name}</h2>
              <div className="jewish-learning-modal-duration">
                <FaClock className="jewish-learning-modal-duration-icon" />
                <span>{selectedFellowship.duration}</span>
              </div>
              <div className="jewish-learning-modal-contact">
                <FaEnvelope className="jewish-learning-modal-email-icon" />
                <a 
                  href={`mailto:${selectedFellowship.contact.email}`}
                  className="jewish-learning-modal-contact-link"
                >
                  {selectedFellowship.contact.name}
                </a>
              </div>
            </div>
            <div className="jewish-learning-modal-body">
              <RichText value={selectedFellowship.description} className="jewish-learning-modal-description" />
              
              {selectedFellowship.applicationStatus === 'open' ? (
                <div className="jewish-learning-modal-application">
                  <a 
                    href={selectedFellowship.applicationLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="jewish-learning-modal-application-link"
                  >
                    Apply Now <FaExternalLinkAlt />
                  </a>
                </div>
              ) : selectedFellowship.applicationStatus === 'coming-soon' ? (
                <div className="jewish-learning-modal-application-coming-soon">
                  <p>Applications will be opening soon! Check back for updates.</p>
                </div>
              ) : (
                <div className="jewish-learning-modal-application-closed">
                  <p>Applications for this semester are now closed. Check back next semester!</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JewishLearning; 